import React from 'react'
import { translate } from '../Services/translation'

function VehicleData({ vehicleData, removeVehicle }) {
    return (
        vehicleData && (
            <div className="filter-vehicle-data">
            <div className="vehicle-finder__vehicle-data-container--regno-container">
                <i className="icon-car"></i>&nbsp;
                {vehicleData.registrationNumber
                    ? vehicleData.registrationNumber
                    : vehicleData.manufacturer}
                <a className="remove-vehicle" onClick={() => removeVehicle()}>
                    {translate('vehiclefinder.remove')}
                </a>
            </div>
            <div className="vehicle-spec-container">
                <div>
                    {vehicleData.registrationNumber ? vehicleData.manufacturer + ' ' : ''}
                    {vehicleData.modelFullName || vehicleData.model} {vehicleData.modelYearRange}
                </div>
            </div>
        </div>
        )
    )
}

export default VehicleData
